/**
 * Headlight Popover CSS
 *
 * Re-skins the pict-section-modal dropdown surface used by the HeadlightPopover
 * service (migrated off Tippy.js). Ported from the former `bulma-tippy`
 * dropdown / dropdown-dark themes, re-scoped under the wrapper's className and
 * driven by Bulma theme tokens so it follows the active light/dark theme.
 *
 * The service opens popovers via `modal.dropdown({ ContentHTML })`, which adds
 * the `pict-modal-dropdown--content` modifier (padding: 0, max-width uncapped).
 * These rules restore the menu chrome the old Tippy `dropdown` theme provided.
 */
module.exports = /*css*/`
/* Restore the inner padding the --content modifier zeroes out, and lift the
   popover above host chrome. PSM's dropdown is position:fixed at z-index 1025,
   but Headlight-Panels' shell stacks up to ~1060 (side panels 1040, navbar
   1050, navbar+10 1060), which would occlude the menu. Tippy previously used
   9999; match it so the popover clears all panel chrome as before. */
.pict-modal-dropdown.headlight-popover
{
	padding: 0.25rem;
	z-index: 9999;
}

/* Action menus rendered inside the popover template (<ul class="list-menu">). */
.headlight-popover .list-menu
{
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item
{
	padding: 0;
	margin: 0;
}

.headlight-popover .list-menu-item a
{
	display: flex;
	align-items: center;
	padding: 0.5rem 1rem;
	color: var(--bulma-text);
	text-decoration: none;
}

.headlight-popover .list-menu-item:hover
{
	background-color: var(--bulma-background);
}

.headlight-popover .list-menu-item:hover a
{
	color: var(--bulma-primary);
}

/* Dark variant (legacy Tippy theme 'dropdown-dark'). Overrides the dropdown
   surface tokens + the list-menu hover colors. Declared after the light rules
   so it wins at equal specificity when both classes are on the element. */
.pict-modal-dropdown.headlight-popover-dark
{
	--pict-modal-dropdown-bg: var(--bulma-black-ter);
	--pict-modal-dropdown-fg: var(--bulma-white);
	--pict-modal-dropdown-border: var(--bulma-black-ter);
}

.headlight-popover-dark .list-menu-item a
{
	color: var(--bulma-primary-85);
}

.headlight-popover-dark .list-menu-item:hover
{
	background-color: var(--bulma-primary-20);
}

.headlight-popover-dark .list-menu-item:hover a
{
	color: var(--bulma-primary-85);
}
`;
